// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__28-l6","footer":"ModalInfo_footer__5on0a"};